const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

export function isAnalyticsEnabled() {
  return Boolean(MEASUREMENT_ID);
}

export function getMeasurementId() {
  return MEASUREMENT_ID;
}

function gtagSafe(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function initGA() {
  if (!isAnalyticsEnabled()) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!isAnalyticsEnabled()) return;
  gtagSafe("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(eventName, params = {}) {
  if (!isAnalyticsEnabled()) return;
  gtagSafe("event", eventName, params);
}
